import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.promise.js";
import React from 'react';
import { rehydrateMarks } from 'react-imported-component';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { ClientApp } from './ClientApp';
var renderBrowserReactApp = function renderBrowserReactApp(_ref) {
  var initializedStore = _ref.initializedStore,
    BrowserApp = _ref.BrowserApp;
  var container = document.getElementById('app');
  var root = createRoot(container);
  root.render(React.createElement(ClientApp, null, React.createElement(BrowserApp, {
    initializedStore: initializedStore
  })));
};
var hydrateBrowserReactApp = function hydrateBrowserReactApp(_ref2) {
  var initializedStore = _ref2.initializedStore,
    BrowserApp = _ref2.BrowserApp;
  var container = document.getElementById('app');
  hydrateRoot(container, React.createElement(ClientApp, null, React.createElement(BrowserApp, {
    initializedStore: initializedStore
  })));
};
export var renderClientApp = function renderClientApp(settings) {
  var options = {};
  settings.initMiddlewares.forEach(function (middleware) {
    options = middleware(options, settings);
  });
  Promise.resolve().then(function () {
    return Promise.resolve().then(function () {
      rehydrateMarks().then(function () {
        var params = {
          initializedStore: options.initializedStore,
          BrowserApp: settings.BrowserApp
        };
        if (process.env.NODE_ENV === 'production') {
          hydrateBrowserReactApp(params);
        } else {
          renderBrowserReactApp(params);
        }
      });
    });
  });
};